import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[color:var(--brand-navy-alt)] text-white" data-testid="site-footer">
      <div className="container-x py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="inline-flex items-center justify-center h-10 w-10 rounded-xl bg-white/10">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 11.5 12 5l8 6.5V20a1 1 0 0 1-1 1h-4v-5h-6v5H5a1 1 0 0 1-1-1v-8.5Z" stroke="#7AB648" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
              </span>
              <span className="font-display text-2xl">HAUSNOTRUF</span>
            </div>
            <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-xs">Sicherheit, auf die Sie sich verlassen können. Sicherheit beginnt zuhause – wir beraten Sie gerne.</p>
          </div>

          <div>
            <h3 className="font-bold text-base">Kontakt</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/80">
              <li className="font-semibold">{COMPANY.name}</li>
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[color:var(--brand-green)]" /> {COMPANY.street}, {COMPANY.zip} {COMPANY.city}</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[color:var(--brand-green)]" /> <a href={`tel:${COMPANY.phoneHref}`} className="hover:underline">{COMPANY.phoneDisplay}</a></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[color:var(--brand-green)]" /> <a href={`mailto:${COMPANY.email}`} className="hover:underline">{COMPANY.email}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-base">Rechtliches</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/80">
              <li><Link to="/impressum" data-testid="footer-impressum-link" className="hover:underline">Impressum</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:underline">Datenschutz</Link></li>
              <li><Link to="/agb" data-testid="footer-agb-link" className="hover:underline">AGB</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/60">
          <p>© {year} {COMPANY.name}. Alle Rechte vorbehalten.</p>
          <p>Hausnotruf – Senioren SOS System für Zuhause · Dortmund &amp; deutschlandweit</p>
        </div>
      </div>
    </footer>
  );
}
